/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElEmpty as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import __unplugin_components_4 from '~icons/ep/link';
import { ElIcon as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_2 from '~icons/ep/fold';
import { ElCheckbox as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "flex flex-wrap"
};
const _hoisted_2 = {
  key: 0,
  class: "noData"
};
import EditPlugin from './editPlugin.vue';
import { apiUsdkGetChannelPlugins, apiUsdkGetChannelPluginsNew, apiUsdkGetCpsPlugins, apiUsdkSaveChannelPluginsNew } from '@/api/usdk';
import { UseComProps } from './hooks';
import UQuestion from '@ultra/share/components/UQuestion/index.vue';
import { DICT_PLUG_TIPS } from './pluginConfig';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'plugConfig',
  props: {
    ...UseComProps(),
    activeName: {
      type: String,
      default: ''
    },
    isCps: {
      type: Boolean,
      default: false
    },
    cpsId: {
      type: [Number, String],
      default: ''
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const allPlugins = ref([]);
    const cardList = ref([]);
    const selectedIds = ref([]);
    const oldSelectedIds = ref([]);
    const tableLoading = ref(false);
    const isSave = ref(true);
    const editPluginRef = ref();
    const typeOptions = ['', '推送组件', '广告组件', '数据组件', '其他组件', '客服组件'];
    // 跳转链接
    const handleToLink = link => {
      window.open(link);
    };
    const handleOpenPlugin = (data, title) => {
      editPluginRef.value.show({
        data,
        gid: props.gid,
        channel: props.channel,
        selectedIds: selectedIds.value,
        allPlugins: allPlugins.value
      });
      editPluginRef.value.title = title;
    };
    const handleOpenSwitch = computed(() => {
      return function (t) {
        return selectedIds.value.includes(t.pid);
      };
    });
    const toogleSwitch = (val, t) => {
      if (val) {
        selectedIds.value.push(t.pid);
      } else {
        let index = selectedIds.value.indexOf(t.pid);
        selectedIds.value.splice(index, 1);
      }
    };
    // 获取所有插件
    const getAllPlugins = async () => {
      cardList.value = [];
      if (props.gid) {
        tableLoading.value = true;
        await apiUsdkGetChannelPluginsNew({
          gid: props.gid,
          cid: props.isCps ? '' : props.channel.cid
        }).then(res => {
          if (res.code === 0) {
            let plugins = {};
            res.data.forEach(item => {
              item.items.forEach(c => {
                if ([2, 5].includes(Number(c.type))) {
                  c.defValueFormat = c.defValue.split(',');
                }
                if (Number(c.type) === 2) {
                  c.valueFormat = c.value || '';
                }
                if ([3, 4, 5].includes(Number(c.type))) {
                  c.valueFormat = c.value ? c.value.split(',') : [];
                }
              });
              if (!plugins[item.type]) {
                plugins[item.type] = [];
              }
              item.tipConf = DICT_PLUG_TIPS[item.name];
              plugins[item.type].push(item);
            });
            allPlugins.value = plugins;
            console.log('allPlugins', allPlugins.value);
            for (const key in allPlugins.value) {
              cardList.value.push({
                isOpen: false,
                active: typeOptions[key],
                panes: [{
                  title: `${typeOptions[key]}（${allPlugins.value[key].length}）`,
                  key: typeOptions[key],
                  level: 0
                }],
                plugins: allPlugins.value[key]
              });
              // allPlugins.value[key].forEach((item: any) => {
              // 	cardList.value[key].panes.push({ title: item.name, key: item.name, level: 1 });
              // });
            }
          }
        }).finally(() => {
          tableLoading.value = false;
        });
      }
    };
    const getChannlePlugin = async () => {
      if (props.isCps) {
        await apiUsdkGetCpsPlugins({
          plcId: props.cpsId
        }).then(res => {
          if (res.code === 0) {
            // const _allPlugins = Object.values(allPlugins.value);
            const _allPlugins = Object.values(allPlugins.value);
            _allPlugins.forEach(_ => {
              _.forEach(p => {
                selectedIds.value = [];
                const current = res.data.find(item => item.pid === p.pid);
                if (current.enable) {
                  selectedIds.value.push(current.pid);
                }
                p.items.forEach(k => {
                  current.items.forEach(pk => {
                    if (k.key === pk.key) {
                      if ([2, 5].includes(Number(k.type))) {
                        k.defValueFormat = pk.defValue.split(',');
                      }
                      if ([2, 3, 4, 5].includes(Number(k.type))) {
                        if (pk.value && pk.value.indexOf(',') > -1) {
                          k.valueFormat = pk.value.split(',');
                        } else {
                          k.valueFormat = pk.value;
                        }
                      }
                      k.value = pk.value;
                    }
                  });
                });
              });
            });
          }
        });
      } else {
        await apiUsdkGetChannelPlugins({
          gid: props.gid,
          cid: props.channel.cid
        }).then(res => {
          if (res.code === 0) {
            selectedIds.value = res.data || [];
          }
        });
      }
    };
    // 构建参数
    const createParams = () => {
      let opendPlugins = [];
      for (let key in allPlugins.value) {
        allPlugins.value[key].forEach(item => {
          if (selectedIds.value.includes(item.pid)) {
            opendPlugins.push(item);
          }
        });
      }
      let plusItemList = [];
      let isConf = [];
      opendPlugins.forEach(item => {
        isConf.push({
          name: item.name,
          conf: item.items.filter(item => item.value || item.valueFormat).length
        });
        item.items.forEach(c => {
          var _props$channel;
          if ([2, 3, 4, 5].includes(Number(c.type))) {
            c.value = Array.isArray(c.valueFormat) ? c.valueFormat.join(',') : c.valueFormat;
          }
          const obj = {
            id: c.hccpiid,
            cid: (_props$channel = props.channel) === null || _props$channel === void 0 ? void 0 : _props$channel.cid,
            gid: props.gid,
            pid: c.pid,
            ptid: c.id,
            ptkey: c.key,
            value: c.value
          };
          plusItemList.push(obj);
        });
      });
      // 插件参数 必填一项
      let pName = isConf.filter(item => item.conf === 0).map(item => item.name).join(',');
      console.log('isConf', isConf);
      console.log('pName', pName);
      if (pName) {
        isSave.value = false;
        ElMessage({
          type: 'warning',
          message: `${pName}插件的参数不能为空!`
        });
        return {
          plugs: [],
          plusItemList: []
        };
      }
      let params = {
        plugs: selectedIds.value,
        plusItemList
      };
      isSave.value = true;
      return params;
    };
    const handleSavePlugin = () => {
      var _props$channel2;
      const dict = {
        plugs: {
          name: '插件开关'
        }
      };
      const {
        plugs,
        plusItemList
      } = createParams();
      if (!isSave.value) {
        return;
      }
      const params = {
        gid: props.gid,
        cid: (_props$channel2 = props.channel) === null || _props$channel2 === void 0 ? void 0 : _props$channel2.cid,
        plugs: plugs.join(','),
        plusItemList: JSON.stringify(plusItemList)
      };
      apiUsdkSaveChannelPluginsNew(params).then(res => {
        if (res.code === 0) {
          handleSuccess();
          customDataReport({
            eventName: 'plugin_config',
            dict,
            before: {
              plugs: oldSelectedIds.value
            },
            after: {
              plugs: selectedIds.value
            },
            operatePath: '出包-渠道配置-插件配置',
            gid: props.gid
          });
        }
      });
    };
    const handleSuccess = async () => {
      if (props.isCps) return;
      await getAllPlugins();
      await getChannlePlugin();
    };
    watch(() => props.activeName, async val => {
      if (val === 'pluginConf') {
        await getAllPlugins();
        await getChannlePlugin();
        oldSelectedIds.value = JSON.parse(JSON.stringify(selectedIds.value));
      }
    }, {
      immediate: true
    });
    expose({
      createParams
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_checkbox = __unplugin_components_1;
      const _component_i_ep_Fold = __unplugin_components_2;
      const _component_el_icon = __unplugin_components_3;
      const _component_i_ep_link = __unplugin_components_4;
      const _component_u_card = _resolveComponent("u-card");
      const _component_el_empty = __unplugin_components_5;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [!props.isCps ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#pluginConf"
      }, [_unref(cardList).length > 0 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        onClick: handleSavePlugin
      }, {
        default: _withCtx(() => [_createTextVNode("保存插件12")]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", null, [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cardList), (item, index) => {
        return _openBlock(), _createBlock(_component_u_card, {
          key: index,
          title: item.active,
          class: "plugConfig",
          disabled: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.plugins, p => {
            return _openBlock(), _createElementBlock("div", {
              key: p.pid,
              class: "marginR50 flex items-center"
            }, [_unref(handleOpenSwitch)(p) ? (_openBlock(), _createBlock(_component_el_checkbox, {
              key: 0,
              checked: true,
              label: p.name,
              size: "large",
              onChange: e => toogleSwitch(e, p)
            }, null, 8, ["label", "onChange"])) : (_openBlock(), _createBlock(_component_el_checkbox, {
              key: 1,
              checked: false,
              label: p.name,
              size: "large",
              onChange: e => toogleSwitch(e, p)
            }, null, 8, ["label", "onChange"])), _unref(handleOpenSwitch)(p) ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 2,
              class: "cp marginL10",
              color: "blue",
              onClick: $event => handleOpenPlugin(p.items, p.name)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_Fold)]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), p.tipConf && p.tipConf.link ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 3,
              class: "marginL10",
              style: {
                "color": "blue",
                "cursor": "pointer"
              },
              onClick: $event => handleToLink(p.tipConf.link)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_link)]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), p.tipConf && p.tipConf.tips ? (_openBlock(), _createBlock(UQuestion, {
              key: 4
            }, {
              default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString(p.tipConf.tips), 1)]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)]);
          }), 128))])]),
          _: 2
        }, 1032, ["title"]);
      }), 128))]), _unref(cardList).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_unref(cardList).length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        description: "未配置插件"
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])), [[_directive_loading, _unref(tableLoading)]]), _createVNode(EditPlugin, {
        ref_key: "editPluginRef",
        ref: editPluginRef,
        onSuccess: handleSuccess
      }, null, 512)], 64);
    };
  }
});